import React, { useMemo } from "react";
import '../../../style.css';

const coordKey = (r, c) => `${r}-${c}`;

export default function LeftPart({
  board,
  lines,
  placedValues,
  slotExpected,
  onPlace,
  state,
}) {
  const slotMap = useMemo(() => {
    const map = {};

    Object.keys(slotExpected).forEach((key) => {
      map[key] = {
        value: slotExpected[key],
        isSlot: true,
      };
    });

    return map;
  }, [slotExpected]);

  const handleSlotClick = (key) => {
    onPlace?.(key);
  };

  return (
    <div
      className={`flex items-center justify-center ${state ? "leftpartIsStateWidth" : "leftpartIsNotStateWidth"}  h-full border-[3px] rounded-[16px] lg:rounded-[20px] border-[#7648B5] bg-[#FFF] `}
    >
      <div className="px-3 my-auto h-full">
        {board.map((row, rIdx) => (
          <div key={rIdx} className="flex">
            {row.map((cell, cIdx) => {
              const key = coordKey(rIdx, cIdx);

              const slot = slotMap[key];
              const isSlot = !!slot;

              const placed = placedValues[key];

              const isNumber =
                cell !== "" &&
                !["+", "-", "x", "/", "="].includes(cell);

              return (
                <div
                  key={cIdx}
                  data-slot={isSlot ? key : undefined}
                  onClick={() =>
                    isSlot && handleSlotClick(key)
                  }
                  className={`
                  xl:w-[35px] xl:h-[35px] xl:w-[35px] xl:h-[35px] lg:w-[30px] lg:h-[30px] md:w-[25px] md:h-[25px] sm:w-[20px] sm:h-[20px] w-[15px] h-[15px]
                    
                    flex
                    items-center
                    justify-center
                    text-[18px]
                    font-bold
                    select-none
                    transition-all
                    duration-200
                    rounded-[8px]

                    ${
                      isSlot
                        ? "bg-[#EDF3E4] border border-[#909B84] cursor-pointer"
                        : cell
                        ? "border border-[#909B84] bg-[#D4E4C2]"
                        : "border border-transparent"
                    }

                    ${
                      placed
                        ? "bg-[#D4E4C2]"
                        : ""
                    }
                  `}
                >
                  {/* operators */}
                  {!isSlot &&
                    cell &&
                    !isNumber && (
                      <span className="text-[#333]">
                        {cell}
                      </span>
                    )}

                  {/* visible numbers */}
                  {!isSlot &&
                    isNumber && (
                      <span className="text-[#111]">
                        {cell}
                      </span>
                    )}

                  {/* empty slot */}
                  {isSlot &&
                    !placed && (
                      <span className="text-[#999]">
                        ?
                      </span>
                    )}

                  {/* placed value */}
                  {isSlot &&
                    placed && (
                      <span className="text-[#111]">
                        {placed}
                      </span>
                    )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}